import * as __WEBPACK_EXTERNAL_MODULE_json_stringify_safe_eb014bbd__ from "json-stringify-safe";
const MAX_EXTRA_DATA_LENGTH = 102400;
const removeExtraData = (event)=>{
    const extraDataLength = (0, __WEBPACK_EXTERNAL_MODULE_json_stringify_safe_eb014bbd__["default"])(event.extra).length;
    if (extraDataLength > MAX_EXTRA_DATA_LENGTH) event.extra = {
        __removed: `Extra data is too large and has been stripped (${extraDataLength}/${MAX_EXTRA_DATA_LENGTH})`
    };
};
export { MAX_EXTRA_DATA_LENGTH, removeExtraData };

//# sourceMappingURL=removeData.mjs.map